export default __webpack_public_path__ + "static/media/img--interiors-3.8ccd4bbc.jpg";